import { sv as svLocale } from 'date-fns/locale/sv';

const formatRelativeLocale = {
  lastWeek: 'd MMM',
  yesterday: "'Igår' HH:mm",
  today: "'Idag' HH:mm",
  tomorrow: "'Imorgon' HH:mm",
  nextWeek: 'd MMM',
  other: 'd MMM y',
};

export const relativeLocale = {
  ...svLocale,
  formatRelative: (token: keyof typeof formatRelativeLocale): string =>
    formatRelativeLocale[token],
};

export const relativeDayLocale = {
  ...svLocale,
  formatRelative: (token: string): string => {
    switch (token) {
      case 'yesterday':
        return "'igår'";
      case 'today':
        return "'idag'";
      case 'tomorrow':
        return "'imorgon'";
      case 'nextWeek':
        return 'EEEE';
      default:
        return 'd/M';
    }
  },
};

export const relativeDayAndTimeLocale = {
  ...svLocale,
  formatRelative: (token: string): string => {
    switch (token) {
      case 'yesterday':
        return "'igår' HH:mm";
      case 'today':
        return "'idag' HH:mm";
      case 'tomorrow':
        return "'imorgon' HH:mm";
      case 'nextWeek':
        return 'EEEE HH:mm';
      default:
        return 'd/M HH:mm';
    }
  },
};

export { sv as svLocale } from 'date-fns/locale/sv';
